<template>
  <div>
    <!--  Bộ lọc  -->
    <div>
      <el-row type="flex">
        <el-col :span="20">
          <el-row type="flex" :gutter="4">

            <el-col :span="3">
              <el-select
                  v-model="dataFilter.statusActive"
                  placeholder="Trạng thái phiếu" style="width: 100%"
                  @change="handleFilterData"
                  :clearable="true"
              >
                <el-option
                    v-for="(item, index) in optionsStatusForm"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>



            <el-col :span="6">
              <el-date-picker
                  style="width: 100%"
                  v-model="dataFilter.dateRange"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Thời gian tạo"
                  end-placeholder="Thời gian tạo"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                  @change="handleFilterData"
              >
              </el-date-picker>
            </el-col>

            <el-col :span="3">
              <el-select
                  v-model="dataFilter.type"
                  placeholder="Loại phiếu" style="width: 100%"
                  @change="handleFilterData"
                  :clearable="true"
              >
                <el-option
                    v-for="(item, index) in optionsTypeApply"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>

            <el-col :span="6">
              <el-input
                  :clearable="true"
                  style="width: 100%"
                  placeholder="Nhập tiêu đề hoặc mã phiếu"
                  v-model="dataFilter.name"
                  @keyup.enter.native="handleFilterData"
                  @clear="handleFilterData"
              >
                <template #append>
                  <el-button
                      icon="el-icon-search"
                      @click="handleFilterData"
                  ></el-button>
                </template>
              </el-input>
            </el-col>

            <el-col :span="1">
              <el-button
                  style="
                    width: 100%;
                    padding-left: 10px;
                    padding-right: 10px;"
                  plain
                  :type="isAdvancedFilter ? 'danger' : 'primary'"
                  @click="handleOpenAdvancedFilter"
                  :icon="'el-icon-circle-plus'"/>
            </el-col>

            <el-col :span="1" v-if="isAdvancedFilter">
              <el-button
                  style="
                    width: 100%;
                    padding-left: 10px;
                    padding-right: 10px;"
                  type="danger"
                  plain
                  @click="handleResetAdvancedFilter"
                  :icon="'el-icon-refresh-left'"/>
            </el-col>

          </el-row>
        </el-col>

        <el-col :span="4">
          <el-row type="flex" :justify="'end'">
            <el-col :span="11">
              <el-button style="width: 100%" type="success" @click="handleOpenCreateDialog">
                <i class="el-icon-plus"/>
                Thêm mới
              </el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <div>
      <slot
          :data="dataTableSurveyForm"
          :is_loading="isLoading"
      />
    </div>

    <!--  Tác vụ  -->
    <div class="footer_task">
      <el-row type="flex">
        <el-col :span="16">
          <div class="container_nav_page">
            <el-pagination
                style=" margin-right: 200px"
                background
                layout="prev, pager, next, sizes"
                @size-change="handleSizeChange"
                @current-change="handleCurrentPageChange"
                :current-page.sync="dataFilter.page"
                :page-sizes="listSizePage"
                :total="totalRecords">
            </el-pagination>
          </div>
        </el-col>

        <el-col :span="8">
          <el-row type="flex" :justify="'end'">
            <el-col :span="5">
              <el-menu
                  class="menu_task_form"
                  background-color="#67C23A"
                  text-color="#FFF"
                  active-text-color="#FFF"
                  mode="horizontal"
                  :unique-opened="true"
                  menu-trigger="hover"
              >
                <el-submenu index="1" popper-class="sub_menu">
                  <template #title>
                    Tác vụ
                  </template>
                  <el-menu-item index="2" @click="handleRemoveMultipleForm" class="submenu-left">
                    <template #title  v-if="dataFilter.statusActive===1">Ẩn phiếu khảo sát</template>
                  </el-menu-item>
                </el-submenu>
              </el-menu>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <!--  Dialog  -->
    <!--  Tạo mới phiếu  -->
    <CreateSurveyForm
        :is-open="isOpenDialog.createSurveyForm"
        @closeDialog="handleCloseCreateDialog"
    />

    <!--  Bộ lọc nâng cao  -->
    <AdvancedFiltersForm
        :is-open="isOpenDialog.advancedFilter"
        @closeDialog="handleCloseAdvancedFilter"
        @saveDialog="handleSaveAdvancedFilter"
        ref="advancedFiltersForm"
    />
  </div>
</template>

<script>

import CreateSurveyForm from "@/views/survey_form/dialog/CreateSurveyForm.vue";
import SurveyForm from "@/services/SurveyForm";
import {mapState} from "vuex";
import AdvancedFiltersForm from "@/views/survey_form/dialog/AdvancedFiltersForm.vue";

export default {
  components: {AdvancedFiltersForm, CreateSurveyForm},
  computed: {
    ...mapState('classStore', ['classListCommon']),
  },
  data() {
    return {
      isOpenDialog: {
        createSurveyForm: false,
        advancedFilter: false,
      },
      dataTableSurveyForm: [],
      totalRecords: 0,
      dataFilter: {
        statusActive:1,
        type: "",
        name: "",
        idClass: "",
        page: 1,
        limit: 10,
        dateRange: null,
      },

      advancedFilter: {
        applyTime: null,
        firstDay: "",
        lastDay: ""
      },

      isLoading: false,
      optionsTypeApply: [
        {
          value: "plus",
          label: "Nhà Trường"
        },
        {
          value: "teacher",
          label: "Giáo viên"
        }
      ],
      optionsStatusForm: [
        {
          value: 1,
          label: "Đang sử dụng"
        },
        {
          value: 0,
          label: "Đã ẩn"
        }
      ],
      listSizePage: [10, 30, 40, 50, 100, 200, 500],
      classListFilter: [],
      isAdvancedFilter: false,
    }
  },

  watch: {
    "advancedFilter.applyTime"(newVal) {
      this.isAdvancedFilter = newVal !== null;
    }
  },

  created() {
    this.fetchDataTableSurveyForm();

    this.$store.dispatch('classStore/fetchDataClassListCommon');
  },
  methods: {
    fetchDataTableSurveyForm() {
      const data = {
        delActive:this.dataFilter.statusActive,
        typeform: this.dataFilter.type,
        nameFormOrId: this.checkSearchNameOrId(),
        idClass: this.dataFilter.idClass,
        pageNumber: this.dataFilter.page,
        maxPageItem: this.dataFilter.limit,
        fistTimeCreate: this.dataFilter.dateRange ? this.dataFilter.dateRange[0] : "",
        lastTimeCreate: this.dataFilter.dateRange ? this.dataFilter.dateRange[1] : "",
        apply: this.advancedFilter.applyTime === null ? "" : this.advancedFilter.applyTime,
        fistTimeApply: this.advancedFilter.firstDay,
        lastTimeApply: this.advancedFilter.lastDay,
      }

      this.isLoading = true;
      SurveyForm.getDataTableSurveyForm(data)
          .then((res) => {
            const data = res.data.data;
            this.dataTableSurveyForm = data.responseList ? data.responseList : [];
            this.totalRecords = data.totalRecords;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.isLoading = false;
          })
    },

    handleOpenCreateDialog() {
      this.isOpenDialog.createSurveyForm = true;
    },

    handleCloseCreateDialog() {
      this.isOpenDialog.createSurveyForm = false;
      this.fetchDataTableSurveyForm();
    },

    handleFilterData() {
      this.dataFilter.page = 1;
      this.fetchDataTableSurveyForm();
    },

    handleSizeChange(value) {
      this.dataFilter.limit = value;
      this.fetchDataTableSurveyForm();
    },

    handleCurrentPageChange(value) {
      this.dataFilter.page = value;
      this.fetchDataTableSurveyForm();
    },

    handleRemoveMultipleForm() {
      this.$emit("removeMultipleForm")
    },

    handleOpenAdvancedFilter() {
      const data = {
        applyTime: this.advancedFilter.applyTime === null ? null : this.advancedFilter.applyTime,
        firstDay: this.advancedFilter.firstDay,
        lastDay: this.advancedFilter.lastDay,
      }
      this.isOpenDialog.advancedFilter = true;
      this.$refs.advancedFiltersForm.getDataAdvancedFilter(data)
    },

    handleResetAdvancedFilter() {
      this.isAdvancedFilter = false;
      this.advancedFilter = {
        applyTime: null,
        firstDay: "",
        lastDay: "",
      }
      this.fetchDataTableSurveyForm();
    },

    handleCloseAdvancedFilter() {
      this.isOpenDialog.advancedFilter = false;
    },

    handleSaveAdvancedFilter(data) {
      this.advancedFilter = data;
      this.isAdvancedFilter = data.applyTime !== null;
      this.fetchDataTableSurveyForm();
      this.handleCloseAdvancedFilter();
    },

    checkSearchNameOrId() {
      const regexId = /^FORM_(\d+)(?:_\d{8})?$/;
      const value = this.dataFilter.name;

      if (regexId.test(value)) {
        const id = value.match(regexId);
        return id[1];
      } else {
        return value;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container_nav_page {
  /deep/ .el-pagination {
    display: flex;
    justify-content: end;
  }
}

.footer_task {
  margin-top: 20px;
}

.menu_task_form {
  background-color: transparent !important;
  display: flex;
  justify-content: end;
  align-content: center;
}

/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 36px;
  line-height: 35px;
  border-bottom: 0 solid transparent;
  border-radius: 4px;
}

/deep/ .el-submenu__title i {
  color: #fff;
}
</style>